// client/src/api/services/dashboardService.ts
import { apiClient } from '../client';
import { ENDPOINTS } from '../endpoints';
import { getErrorMessage } from '@/utils/errorUtils';
import { AxiosError } from "axios";

// export interface DashboardData {
//   onlineHotspots: number;
//   onlineChange: number;
//   averageUptime: number;
//   totalEarnings: number;
//   offlineHotspots: number;
// }

/**
 * Fetch dashboard cards data
 */
export const getDashboardOverflow = async (): Promise<unknown> => {
  try {
    const response = await apiClient.get<unknown>(ENDPOINTS.DASHBOARD.OVERFLOWS);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching dashboard cards:', error);
    throw new Error(getErrorMessage(error) || 'Failed to fetch dashboard cards');
  }
};
export const getSubscription = async (): Promise<unknown> => {
  try {
    const response = await apiClient.get<unknown>(ENDPOINTS.DASHBOARD.SUBSCRIPTION);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching dashboard cards:', error);
    throw new Error(getErrorMessage(error) || 'Failed to fetch dashboard cards');
  }
};

export default {
  getDashboardOverflow,
  getSubscription
};
